import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";

import "./CustomerRegister.css";

import RegisterHeader from "../../components/auth/RegisterHeader";
import ProgressStepper from "../../components/auth/ProgressStepper";
import OTPSection from "../../components/auth/OTPSection";
import PasswordSection from "../../components/auth/PasswordSection";

function CustomerRegister() {

    const navigate = useNavigate();

    // ==========================
    // States
    // ==========================

    const [form, setForm] = useState({

        name: "",

        phone: "",

        email: "",

        password: "",

        confirmPassword: ""

    });

    const [otp, setOtp] = useState([

        "", "", "", "", "", ""

    ]);

    const [otpSent, setOtpSent] = useState(false);

    const [otpVerified, setOtpVerified] = useState(false);

    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState("");

    const [statusType, setStatusType] = useState("");

    const [timer, setTimer] = useState(30);

    // ==========================
    // OTP Timer
    // ==========================

    useEffect(() => {

        let interval = null;

        if (otpSent && timer > 0) {

            interval = setInterval(() => {

                setTimer((prev) => prev - 1);

            }, 1000);

        }

        return () => {

            if (interval) clearInterval(interval);

        };

    }, [otpSent, timer]);

    // ==========================
    // Handle Input
    // ==========================

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value

        });

    };

    // ==========================
    // Send OTP
    // ==========================

    const sendOTP = async () => {

        // Name Validation

        const nameRegex = /^[A-Za-z ]{3,50}$/;

        if (!nameRegex.test(form.name.trim())) {

            setStatus("Enter a valid full name.");

            setStatusType("error");

            return;

        }

        // Phone Validation

        const phoneRegex = /^[6-9]\d{9}$/;

        if (!phoneRegex.test(form.phone)) {

            setStatus("Enter a valid 10-digit mobile number.");

            setStatusType("error");

            return;

        }

        // Email Validation

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(form.email)) {

            setStatus("Enter a valid email address.");

            setStatusType("error");

            return;

        }

        try {

            setLoading(true);

            await API.post(

    "/auth/send-email-otp",

    {

        email: form.email,

        name: form.name,

        type: "customer-register",

    }

);

            setOtpSent(true);

            setTimer(30);

            setStatus("OTP sent successfully.");

            setStatusType("success");

        }

        catch (error) {

            setStatus(

                error.response?.data?.message ||

                "Unable to send OTP."

            );

            setStatusType("error");

        }

        finally {

            setLoading(false);

        }

    };

    // ==========================
    // Resend OTP
    // ==========================

    const resendOTP = async () => {

        try {

           await API.post(

    "/auth/send-email-otp",

    {

        email: form.email,

        name: form.name,

        type: "customer-register",

    }

);

            setTimer(30);

            setStatus("OTP resent successfully.");

            setStatusType("success");

        }

        catch (error) {

            setStatus(

                error.response?.data?.message ||

                "Unable to resend OTP."

            );

            setStatusType("error");

        }

    };

    // ==========================
    // Verify OTP
    // ==========================
    const verifyOTP = async () => {

    const enteredOTP = otp.join("");

    if (enteredOTP.length !== 6) {

        setStatus("Please enter the complete 6-digit OTP.");

        setStatusType("error");

        return;

    }

    try {

        await API.post(

            "/auth/verify-email-otp",

            {

                email: form.email,

                otp: enteredOTP

            }

        );

        setOtpVerified(true);

        setStatus("OTP Verified Successfully.");

        setStatusType("success");

    }

    catch (error) {

        setStatus(

            error.response?.data?.message ||

            "Invalid OTP"

        );

        setStatusType("error");

    }

};

// ==========================
// Create Account
// ==========================

const createAccount = async () => {

    if (!otpVerified) {

        setStatus("Please verify OTP first.");

        setStatusType("error");

        return;

    }

    if (!form.password || !form.confirmPassword) {

        setStatus("Please enter password.");

        setStatusType("error");

        return;

    }

    if (form.password !== form.confirmPassword) {

        setStatus("Passwords do not match.");

        setStatusType("error");

        return;

    }

    const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_#])[A-Za-z\d@$!%*?&_#]{8,}$/;

    if (!passwordRegex.test(form.password)) {

        setStatus(

            "Password must contain at least 8 characters, uppercase, lowercase, number and special character."

        );

        setStatusType("error");

        return;

    }

    try {

        setLoading(true);

        const res = await API.post(

            "/auth/register",

            {

                name: form.name,

                phone: form.phone,

                email: form.email,

                password: form.password,

                role: "customer"

            }

        );

        setStatus(res.data.message);

        setStatusType("success");

        setTimeout(() => {

            navigate("/login");

        }, 2000);

    }

    catch (error) {

        setStatus(

            error.response?.data?.message ||

            "Registration Failed"

        );

        setStatusType("error");

    }

    finally {

        setLoading(false);

    }

};
return (

    <div className="customer-register">

        <div className="customer-card">

            <RegisterHeader />

            <ProgressStepper

                step={
                    otpVerified
                        ? 3
                        : otpSent
                        ? 2
                        : 1
                }

            />

            {status && (

                <div

                    className={`status-message ${statusType}`}

                >

                    {status}

                </div>

            )}

            {/* Full Name */}

            <div className="input-group">

                <input

                    type="text"

                    name="name"

                    value={form.name}

                    onChange={handleChange}

                    placeholder=" "

                    disabled={otpSent}

                    required

                />

                <label>Full Name</label>

            </div>

            {/* Phone */}

            <div className="input-group">

                <input

                    type="text"

                    name="phone"

                    value={form.phone}

                    onChange={handleChange}

                    placeholder=" "

                    disabled={otpSent}

                    required

                />

                <label>Phone Number</label>

            </div>

            {/* Email */}

            <div className="input-group">

                <input

                    type="email"

                    name="email"

                    value={form.email}

                    onChange={handleChange}

                    placeholder=" "

                    disabled={otpSent}

                    required

                />

                <label>Email Address</label>

            </div>

            {/* Send OTP */}

            {!otpSent && (

                <button

                    onClick={sendOTP}

                    disabled={loading}

                >

                    {

                        loading

                            ? "Sending OTP..."

                            : "Send OTP"

                    }

                </button>

            )}

            {/* OTP */}

            {otpSent && !otpVerified && (

                <OTPSection

                    otp={otp}

                    setOtp={setOtp}

                    verifyOTP={verifyOTP}

                    timer={timer}

                    resendOTP={resendOTP}

                />

            )}

            {/* Password */}

            {otpVerified && (

                <PasswordSection

                    form={form}

                    handleChange={handleChange}

                    createAccount={createAccount}

                    loading={loading}

                />

            )}

        </div>

    </div>

);

}

export default CustomerRegister;